/* 商户 */
export default [
  // 我要发布
  {
    path: "/merchant/release",
    name: "Merchant_Release",
    title: "我要发布",
    component: "layout/index",
    icon: "coffee",
    isLayout: true,
    isRouter: true,
    isMenu: true,
    children: [
      // 我要发布
      {
        path: "/merchant/release/index",
        name: "Merchant_Release_Index",
        title: "我要发布",
        component: "release_detail/index",
        icon: "coffee",
        isRouter: true,
        isMenu: true,
        isLayout: false,
        children: [],
        role: [],
        parentId: 0,
        // 1 目录 2 菜单 3 按钮
        type: 2,
        auth: "",
      },
      // 我要发布
      {
        path: "/merchant/release/insert",
        name: "Merchant_Release_Insert_Index",
        title: "我要发布",
        component: "release/index",
        icon: "coffee",
        isRouter: true,
        isMenu: true,
        isLayout: false,
        children: [],
        role: [],
        parentId: 0,
        // 1 目录 2 菜单 3 按钮
        type: 2,
        auth: "",
      },
    ],
    role: [],
    parentId: 0,
    // 1 目录 2 菜单 3 按钮
    type: 1,
    auth: "",
  },

  // 咖啡店
  {
    path: "/merchant/coffee",
    name: "Merchant_Coffee",
    title: "咖啡店",
    component: "layout/index",
    icon: "coffee",
    isLayout: true,
    isRouter: true,
    isMenu: true,
    children: [
      // 咖啡店
      {
        path: "/merchant/coffee/index",
        name: "Merchant_Coffee_Index",
        title: "咖啡店",
        component: "coffee/index",
        icon: "coffee",
        isRouter: true,
        isMenu: true,
        isLayout: false,
        children: [],
        role: [],
        parentId: 0,
        // 1 目录 2 菜单 3 按钮
        type: 2,
        auth: "",
      },
    ],
    role: [],
    parentId: 0,
    // 1 目录 2 菜单 3 按钮
    type: 1,
    auth: "",
  },

  // 小镇咖啡店
  {
    path: "/merchant/town_coffee",
    name: "Merchant_Town_Coffee",
    title: "小镇咖啡店",
    component: "layout/index",
    icon: "coffee",
    isLayout: true,
    isRouter: true,
    isMenu: true,
    children: [
      // 小镇咖啡店
      {
        path: "/merchant/town_coffee/index",
        name: "Merchant_Town_Coffee_Index",
        title: "小镇咖啡店",
        component: "town_coffee/index",
        icon: "coffee",
        isRouter: true,
        isMenu: true,
        isLayout: false,
        children: [],
        role: [],
        parentId: 0,
        // 1 目录 2 菜单 3 按钮
        type: 2,
        auth: "",
      },
    ],
    role: [],
    parentId: 0,
    // 1 目录 2 菜单 3 按钮
    type: 1,
    auth: "",
  },

  // 帖子管理
  {
    path: "/merchant/article",
    name: "Merchant_Article",
    title: "帖子管理",
    component: "layout/index",
    icon: "tiezi",
    isLayout: true,
    isRouter: true,
    isMenu: true,
    children: [
      // 帖子管理
      {
        path: "/merchant/article/index",
        name: "Merchant_Article_Index",
        title: "帖子管理",
        component: "article/index",
        icon: "tiezi",
        isRouter: true,
        isMenu: true,
        isLayout: false,
        children: [],
        role: [],
        parentId: 0,
        // 1 目录 2 菜单 3 按钮
        type: 2,
        auth: "",
      },
    ],
    role: [],
    parentId: 0,
    // 1 目录 2 菜单 3 按钮
    type: 1,
    auth: "",
  },

  // 可能合伙人
  {
    path: "/merchant/activity",
    name: "Merchant_Activity",
    title: "可能合伙人",
    component: "layout/index",
    icon: "activity",
    isLayout: true,
    isRouter: true,
    isMenu: true,
    children: [
      // 可能合伙人
      {
        path: "/merchant/activity/index",
        name: "Merchant_Activity_Index",
        title: "可能合伙人",
        component: "activity/index",
        icon: "activity",
        isRouter: true,
        isMenu: true,
        isLayout: false,
        children: [],
        role: [],
        parentId: 0,
        // 1 目录 2 菜单 3 按钮
        type: 2,
        auth: "",
      },
      // 可能合伙人-订单管理
      {
        path: "/merchant/activity/order/index",
        name: "Merchant_Activity_Order_Index",
        title: "订单管理",
        component: "activity/order/index",
        icon: "activity",
        isRouter: true,
        isMenu: true,
        isLayout: false,
        children: [],
        role: [],
        parentId: 0,
        // 1 目录 2 菜单 3 按钮
        type: 2,
        auth: "",
      },
    ],
    role: [],
    parentId: 0,
    // 1 目录 2 菜单 3 按钮
    type: 1,
    auth: "",
  },

  // 职位管理
  {
    path: "/merchant/vagrant",
    name: "Merchant_Vagrant",
    title: "职位管理",
    component: "layout/index",
    icon: "gongwei",
    isLayout: true,
    isRouter: true,
    isMenu: true,
    children: [
      // 职位管理
      {
        path: "/merchant/vagrant/index",
        name: "Merchant_Vagrant_Index",
        title: "职位管理",
        component: "vagrant/index",
        icon: "gongwei",
        isRouter: true,
        isMenu: true,
        isLayout: false,
        children: [],
        role: [],
        parentId: 0,
        // 1 目录 2 菜单 3 按钮
        type: 2,
        auth: "",
      },
    ],
    role: [],
    parentId: 0,
    // 1 目录 2 菜单 3 按钮
    type: 1,
    auth: "",
  },

  // 报名管理
  {
    path: "/merchant/apply",
    name: "Merchant_Apply",
    title: "报名管理",
    component: "layout/index",
    icon: "baomingxinxi",
    isLayout: true,
    isRouter: true,
    isMenu: true,
    children: [
      // 报名管理
      {
        path: "/merchant/apply/index",
        name: "Merchant_Apply_Index",
        title: "报名管理",
        component: "apply/index",
        icon: "baomingxinxi",
        isRouter: true,
        isMenu: true,
        isLayout: false,
        children: [],
        role: [],
        parentId: 0,
        // 1 目录 2 菜单 3 按钮
        type: 2,
        auth: "",
      },
    ],
    role: [],
    parentId: 0,
    // 1 目录 2 菜单 3 按钮
    type: 1,
    auth: "",
  },

  // AI服务管理
  {
    path: "/merchant/awaken",
    name: "Merchant_Awaken",
    title: "AI服务管理",
    component: "layout/index",
    icon: "model",
    isLayout: true,
    isRouter: true,
    isMenu: true,
    children: [
      // AI服务管理
      {
        path: "/merchant/awaken/index",
        name: "Merchant_Awaken_Index",
        title: "AI服务管理",
        component: "awaken/index",
        icon: "model",
        isRouter: true,
        isMenu: true,
        isLayout: false,
        children: [],
        role: [],
        parentId: 0,
        // 1 目录 2 菜单 3 按钮
        type: 2,
        auth: "",
      },
    ],
    role: [],
    parentId: 0,
    // 1 目录 2 菜单 3 按钮
    type: 1,
    auth: "",
  },
];
